import {getCurrentUser, loginUser} from 'actions/userActions';
import TextInput from 'components/common/TextInput';
import uiHelper from 'helpers/uiHelper';
import validationHelper from 'helpers/validationHelper';
import {isEmpty} from 'lodash';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import AuthBackgroundImage from './components/AuthBackgroundImage';
import AuthBodyContainer from './components/AuthBodyContainer';
import AuthContainer from './components/AuthContainer';
import AuthLink from './components/AuthLink';
import AuthTitle from './components/AuthTitle';
import SubmitButton from './components/SubmitButton';

function LoginPage() {
  const currentUser = useSelector((state: any) => state.user.current);

  const dispatch = useDispatch();
  let history = useHistory();

  const [user, setUser] = useState({email: '', password: ''});

  const [errors, setErrors] = useState({email: '', password: ''});

  useEffect(() => {
    if (!isEmpty(currentUser)) history.push('/');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChange(field: string, value) {
    setUser({...user, [field]: value});
  }

  function loginFormIsValid() {
    let newErrors = {
      email: '',
      password: ''
    };

    if (!user.email) {
      newErrors.email = 'Email field is required.';
    } else if (!validationHelper.isValidEmail(user.email)) {
      newErrors.email = 'Email is not valid.';
    }

    if (!user.password) {
      newErrors.password = 'Password field is required.';
    }

    setErrors(newErrors);

    return validationHelper.isEmptyErrorObject(newErrors);
  }

  async function login(e) {
    if (e) e.preventDefault();

    if (!isActiveButton()) return;

    if (!loginFormIsValid()) return;

    let token: any = await dispatch(loginUser(user));

    if (token) {
      let currentUser = await dispatch(getCurrentUser());

      if (!isEmpty(currentUser)) history.push('/');
    } else {
      uiHelper.showError('Invalid email or password');
    }
  }

  function isActiveButton() {
    return user.email && user.password ? true : false;
  }

  function render() {
    let isActive = isActiveButton();

    return (
      <AuthContainer>
        <AuthBackgroundImage />

        <AuthBodyContainer isSignUp={false}>
          <AuthTitle>Login</AuthTitle>

          <form onSubmit={login}>
            <TextInput
              name="email"
              type="email"
              value={user.email}
              onChange={onChange}
              placeholder="Email"
              error={errors.email}
            />

            <TextInput
              name="password"
              type="password"
              value={user.password}
              onChange={onChange}
              placeholder="Password"
              error={errors.password}
            />

            <SubmitButton isActive={isActive} title="Login" onSubmit={login} />
          </form>

          <AuthLink url="/password-forgot" title="Forgot password?" linkText="Reset" />
          <br />
          <br />
          <br />
          <AuthLink url="/sign-up" title="Don’t have an account?" linkText="Signup now and get one month free!" />
        </AuthBodyContainer>
      </AuthContainer>
    );
  }

  return render();
}

export default LoginPage;
